import { Need, Choice } from '../types';

const buildBooleanChoices = (need: Need): Choice[] => {
  if (need.choices) {
    return need.choices;
  }
  if (need.default === 'yes' || need.default === 'no') {
    return [
      { key: true, label: 'Yes' },
      { key: false, label: 'No' },
    ];
  }
  return [
    { key: true, label: 'True' },
    { key: false, label: 'False' },
  ];
};

export default buildBooleanChoices;
